import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { routerReducer, routerMiddleware } from "react-router-redux";
import { browserHistory } from "react-router";
import thunk from "redux-thunk";

import workable from "./modules/workable";


let middlewares = [
  applyMiddleware(
    thunk,
    routerMiddleware(browserHistory),
  )
];

/* eslint-disable no-underscore-dangle */
if (window.__REDUX_DEVTOOLS_EXTENSION__) {
  middlewares.push(window.__REDUX_DEVTOOLS_EXTENSION__());
}

const configureStore = () => {
  return createStore(
    combineReducers({
      workable,
      routing: routerReducer
    }),
    compose(...middlewares)
  );
};

export default configureStore;



// WEBPACK FOOTER //
// ./configureStore.js